import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.LoginPage),
  },
  {
    // Outside the guard on purpose: whoever follows a reset link cannot sign in, which is
    // precisely what they are here to fix.
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password').then((m) => m.ResetPasswordPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/dashboard' },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile').then((m) => m.ProfilePage),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES
          ),
      },
      {
        path: 'contacts',
        loadChildren: () =>
          import('./pages/contacts/contacts.routes').then(
            (m) => m.CONTACTS_ROUTES
          ),
      },
      {
        path: 'visits',
        loadChildren: () =>
          import('./pages/visits/visits.routes').then((m) => m.VISITS_ROUTES),
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./pages/invoices/invoices.routes').then(
            (m) => m.INVOICES_ROUTES
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./pages/orders/orders.routes').then((m) => m.ORDERS_ROUTES),
      },
      {
        path: 'warranty-claims',
        loadChildren: () =>
          import('./pages/warranty-claims/warranty-claims.routes').then(
            (m) => m.WARRANTY_CLAIMS_ROUTES
          ),
      },
      {
        path: 'administration',
        children: [
          {
            path: 'data-import',
            loadComponent: () =>
              import('./pages/administration/data-import/data-import').then(
                (m) => m.DataImportPage
              ),
          },
          {
            path: 'employers',
            loadComponent: () =>
              import(
                './pages/administration/employers/employers-list/employers-list'
              ).then((m) => m.EmployersList),
          },
          {
            path: 'users',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import(
                    './pages/administration/users/users-list/users-list'
                  ).then((m) => m.UsersList),
              },
              {
                path: 'show',
                loadComponent: () =>
                  import(
                    './pages/administration/users/user-detail/user-detail'
                  ).then((m) => m.UserDetail),
              },
              {
                path: 'new',
                loadComponent: () =>
                  import(
                    './pages/administration/users/user-form/user-form'
                  ).then((m) => m.UserForm),
              },
              {
                path: 'edit',
                loadComponent: () =>
                  import(
                    './pages/administration/users/user-form/user-form'
                  ).then((m) => m.UserForm),
              },
            ],
          },
          {
            path: 'task-scheduler',
            loadComponent: () =>
              import(
                './pages/administration/task-scheduler/task-scheduler'
              ).then((m) => m.TaskSchedulerPage),
          },
          {
            path: 'logs',
            loadComponent: () =>
              import('./pages/administration/logs/logs').then((m) => m.LogsPage),
          },
        ],
      },
    ],
  },
];
